import { render } from "./T86infoView.vue?vue&type=template&id=5c038d5e&scoped=true&ts=true"
import script from "./T86infoView.vue?vue&type=script&lang=ts"
export * from "./T86infoView.vue?vue&type=script&lang=ts"

import "./T86infoView.vue?vue&type=style&index=0&id=5c038d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c038d5e"]])

export default __exports__